import React from 'react'
import { connect } from 'react-redux'
import { bool } from 'prop-types'
import Chart from './Chart'
import { isEmpty } from 'lodash'

const SubTypeChart = ({ chart }) => (chart ? <Chart /> : null)

SubTypeChart.defaultProps = {
  chart: false,
}

SubTypeChart.propTypes = {
  chart: bool.isRequired,
}

const mapStateToProps = ({ ui }) => ({ chart: !isEmpty(ui.chartData) })

export default connect(mapStateToProps)(SubTypeChart)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SubTypeChart/index.jsx